import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import MyTickets from './pages/MyTickets';

function App() {
  return (
    <Router>
      {/* الـ Navbar ثابت بره الـ Routes عشان يفضل ظاهر في كل الصفحات */}
      <Navbar />

      {/* المحتوى بيتغير هنا بناءً على اللينك */}
      <div className="container mt-5 text-center">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/my-tickets" element={<MyTickets />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;